export default {"src":"/_next/static/image/src/images/statistic-fees.8163d14f989e5e613bc77c149811bc4b.svg","height":32,"width":32};